module.exports = __webpack_public_path__ + "static/parkplatz-3834db8a212277b45ef1bcf91f48ee8d.PNG";